export const textSquare = (
  <path
    d="M24 5V23L23 24H5L4 23V5L5 4H23L24 5ZM6 22H22V6H6V22ZM17 20H8V18H17V20ZM20 16H8V14H20V16ZM12 12H8V8H12V12Z"
    fill="currentColor"
  />
);

export const textSquareFill = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M24 5V23L23 24H5L4 23V5L5 4H23L24 5ZM8 18V20H17V18H8ZM8 14V16H20V14H8ZM8 8V12H12V8H8Z"
    fill="currentColor"
  />
);
